export const categories = [
  {
    slug: 'entertainment',
    name: '娱乐现场',
    en: 'ENTERTAINMENT',
    desc: '剧组、综艺、演出与艺能行业的现场动向，第一手线索的时间线整理。',
    icon: 'ri-movie-2-line',
    theme: 'accent',
  },
  {
    slug: 'tech',
    name: '科技内幕',
    en: 'TECH',
    desc: '硬件、AI 与互联网公司的产品与供应链细节，带着数据看信号。',
    icon: 'ri-cpu-line',
    theme: 'secondary',
  },
  {
    slug: 'finance',
    name: '财经风向',
    en: 'FINANCE',
    desc: '消费、零售与金融市场里被忽略的账本，官方口径与市场解读对照。',
    icon: 'ri-line-chart-line',
    theme: 'primary',
  },
  {
    slug: 'society',
    name: '民生观察',
    en: 'SOCIETY',
    desc: '社区、教育与公共服务的真实样本，用具体案例说话。',
    icon: 'ri-community-line',
    theme: 'secondary',
  },
  {
    slug: 'lifestyle',
    name: '生活方式',
    en: 'LIFESTYLE',
    desc: '露营、团购与新兴消费习惯的冷热变化，记录潮水退去后的样子。',
    icon: 'ri-leaf-line',
    theme: 'primary',
  },
];